import { postApi } from "./api_instance";

export const createBid = async (info, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/myBids/createBid",
      sendToken: true,
      dispatch,
      data: info,
    });
  } catch (error) {
    throw error;
  }
};
